"use client"

import { useState, useEffect } from "react"
import { useNavigate, useParams, Link } from "react-router-dom"
import { b2cLogin } from "../api/b2cUserApi"
import Swal from "sweetalert2"
import { useOutletContext } from "react-router-dom"

const UserLogin = () => {
  const navigate = useNavigate()
  const { companyName } = useParams()
  const { isB2CAuth } = useOutletContext()

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isB2CAuth) {
      navigate(`/${companyName}`)
    }
  }, [isB2CAuth, navigate, companyName])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const response = await b2cLogin(email, password, companyName)

      if (response.success && response.data.token) {
        Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: response.message,
          timer: 1500,
          showConfirmButton: false,
        })

        // Store token in localStorage
        localStorage.setItem("authToken", response.data.token)
        localStorage.removeItem("companyAuthToken")

        setTimeout(() => {
          window.dispatchEvent(new CustomEvent("authUpdate", { detail: { authToken: response.data.token } }))
        }, 0)

        setTimeout(() => {
          navigate(`/${companyName}`)
        }, 1500)
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: response.message || "Login failed. Please check your credentials.",
        })
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "An error occurred during login",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {/* LOGIN SECTION */}
      <section className="features py-5">
        <div className="container-lg">
          <div className="row g-4 justify-content-center">
            {/* Login Form */}
            <div className="col-lg-5">
              <div className="info-card">
                <h4 className="fw-bold mb-3">Login to Your Account</h4>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <div className="input-group position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{ paddingRight: "45px" }}
                      />
                      <button
                        type="button"
                        className="btn position-absolute top-50 end-0 translate-middle-y border-0 pe-3"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ zIndex: 10, background: "transparent" }}
                        tabIndex="-1"
                      >
                        <i className={`bi ${showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"} text-muted`}></i>
                      </button>
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary-navy w-100" disabled={loading}>
                    {loading ? "Logging in..." : "Login"}
                  </button>

                  <div className="text-center mt-3">
                    <p className="mb-2">
                      <Link
                        to={`/${companyName}/forgot-password`}
                        className="text-muted"
                        style={{ textDecoration: "none", fontSize: "0.9rem" }}
                      >
                        Forgot Password?
                      </Link>
                    </p>
                    <p className="mb-0">
                      Don't have an account?{" "}
                      <Link
                        to={`/${companyName}/signup`}
                        className="fw-bold"
                        style={{ color: "#002B5C", textDecoration: "none" }}
                      >
                        Create Account
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default UserLogin
